import React from 'react';
import PropTypes from 'prop-types';
import { submitCallForSpeakers } from '../utils/services';

const { Consumer, Provider } = React.createContext();

const speakerItem = () => ({
  speakerName: { value: '', touched: false, label: "Speaker's Name" },
  email: { value: '', touched: false, label: 'Email Address' },
  company: { value: '', touched: false, label: 'Company' },
  country: { value: '', touched: false, label: 'Country' },
  speakerBio: { value: '', touched: false, label: 'About Speaker' },
  photo: { value: '', touched: false, label: 'Speakers Photo', error: '' },
  id: 1
});

const initialState = {
  speakerIterator: 2,
  fields: {
    speakers: [speakerItem()],
    talkTitle: { value: '', touched: false, label: 'Talk Title' },
    talkSummary: { value: '', touched: false, label: 'Talk Summary' },
    track: { value: '', touched: false, label: 'Type' },
    stream: { value: [], touched: false, label: 'Talk Theme' },
    talkType: { value: '', touched: false, label: 'Focus' },
    audienceLevel: { value: '', touched: false, label: 'Audience Level' },
    liveCoding: { value: 'no', touched: false, label: 'Live Coding Included' },
    technicalOrBusiness: {
      value: 'technical',
      touched: false,
      label: 'Technical or Business talk'
    },
    twitterPromotion: { value: '', touched: false, label: 'Twitter Promotion Text' },
    fbPromotion: { value: '', touched: false, label: 'Facebook Promotion Text' },
    disclaimer: { value: false, touched: false, label: '' },
    videoDisclaimer: { value: false, touched: false, label: '' }
  },
  formFailed: false,
  formSubmitted: false,
  formSubmitInProgress: false
};

class CallForSpeakersProvider extends React.Component {
  state = { ...initialState };

  updateCFSFieldValue = (fieldName, value) => {
    this.setState(prevState => ({
      ...prevState,
      fields: {
        ...prevState.fields,
        [fieldName]: { ...prevState.fields[fieldName], value, touched: true }
      }
    }));

    if (value === 'Hands-on Lab') this.resetField('stream');
  };

  updateCFSMultipleFieldValue = (fieldName, value, checked) => {
    const { stream } = this.state.fields;
    const newValue = checked ? [...stream.value, value] : stream.value.filter(val => val !== value);

    this.setState(prevState => ({
      ...prevState,
      fields: {
        ...prevState.fields,
        [fieldName]: { ...prevState.fields[fieldName], value: newValue, touched: true }
      }
    }));
  };

  updateSpeaker = (speakerId, fieldName, value, error) => {
    this.setState(prevState => {
      const newSpeakers = [...prevState.fields.speakers];
      const matchSpeaker = newSpeakers.find(s => s.id === speakerId);
      const updatedSpeaker =
        fieldName === 'photo'
          ? { ...matchSpeaker[fieldName], touched: true, value, error }
          : { ...matchSpeaker[fieldName], touched: true, value };
      matchSpeaker[fieldName] = updatedSpeaker;
      return { ...prevState, fields: { ...prevState.fields, speakers: newSpeakers } };
    });
  };

  addSpeaker = () => {
    this.setState(prevState => ({
      ...prevState,
      fields: {
        ...prevState.fields,
        speakers: [
          ...prevState.fields.speakers,
          { ...speakerItem(), id: prevState.speakerIterator }
        ]
      },
      speakerIterator: prevState.speakerIterator + 1
    }));
  };

  removeSpeaker = speakerId => {
    this.setState(prevState => {
      const newSpeakers = prevState.fields.speakers.filter(s => s.id !== speakerId);
      return { ...prevState, fields: { ...prevState.fields, speakers: newSpeakers } };
    });
  };

  resetField = fieldName => {
    this.setState(prevState => ({
      ...prevState,
      fields: {
        ...prevState.fields,
        [fieldName]: initialState.fields[fieldName]
      }
    }));
  };

  resetForm = () => {
    this.setState({
      ...initialState,
      fields: { ...initialState.fields, speakers: [speakerItem()] }
    });
  };

  updateFormStatus = (fieldName, value) => {
    this.setState({ [fieldName]: value });
  };

  submitInProgress = () => {
    this.setState(prevState => ({
      ...prevState,
      formSubmitInProgress: !prevState.formSubmitInProgress
    }));
  };

  submitCFSForm = async () => {
    this.submitInProgress();
    try {
      await submitCallForSpeakers(this.state.fields);
      this.setState({ formSubmitInProgress: false, formSubmitted: true });
    } catch (error) {
      this.setState({ formSubmitInProgress: false, formFailed: true });
    }
  };

  render() {
    return (
      <Provider
        value={{
          ...this.state,
          addSpeaker: this.addSpeaker,
          removeSpeaker: this.removeSpeaker,
          resetForm: this.resetForm,
          submitCFSForm: this.submitCFSForm,
          updateCFSFieldValue: this.updateCFSFieldValue,
          updateCFSMultipleFieldValue: this.updateCFSMultipleFieldValue,
          updateFormStatus: this.updateFormStatus,
          updateSpeaker: this.updateSpeaker
        }}>
        {this.props.children}
      </Provider>
    );
  }
}

CallForSpeakersProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { CallForSpeakersProvider, Consumer as CallForSpeakersConsumer };
